/* VinZone fault-library article behaviour. Text comes from the article markup (data-* attributes), so the same file serves English and Arabic. */
(function () {
  var root = document.querySelector('.vzfa');
  if (!root) return;
  root.classList.remove('no-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* reading progress + TOC */
  var bar = root.querySelector('.rp');
  var art = root.querySelector('article');
  var tocBar = root.querySelector('.toc-bar i');
  var left = root.querySelector('[data-left]');
  var mins = parseInt(root.getAttribute('data-mins') || '6', 10);
  var leftTpl = (left && left.getAttribute('data-left')) || '{n} min left';
  var doneTxt = (left && left.getAttribute('data-done')) || 'Done';
  var items = [].slice.call(root.querySelectorAll('.toc li'));
  var secs = items.map(function (li) {
    var a = li.querySelector('a');
    return a ? document.getElementById(a.getAttribute('href').slice(1)) : null;
  });
  function onScroll() {
    if (!art) return;
    var r = art.getBoundingClientRect();
    var total = r.height - window.innerHeight * 0.6;
    var p = Math.min(1, Math.max(0, -r.top / (total > 0 ? total : 1)));
    if (bar) bar.style.width = (p * 100) + '%';
    if (tocBar) tocBar.style.width = (p * 100) + '%';
    if (left) {
      var n = Math.ceil(mins * (1 - p));
      left.textContent = n > 0 ? leftTpl.replace('{n}', n) : doneTxt;
    }
    var cur = -1;
    secs.forEach(function (s, i) { if (s && s.getBoundingClientRect().top < window.innerHeight * 0.35) cur = i; });
    items.forEach(function (li, i) {
      li.classList.toggle('on', i === cur);
      li.classList.toggle('done', i < cur);
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  /* copy link */
  var copy = root.querySelector('[data-copy]');
  if (copy) copy.addEventListener('click', function () {
    var url = location.origin + location.pathname;
    var ok = copy.getAttribute('data-copied') || 'Link copied';
    var orig = copy.textContent;
    function done() { copy.textContent = ok; setTimeout(function () { copy.textContent = orig; }, 1800); }
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
  });

  /* symptom checklist */
  var boxes = [].slice.call(root.querySelectorAll('.checks input'));
  var cnt = root.querySelector('.sym-count');
  function count() {
    if (!cnt) return;
    var n = boxes.filter(function (b) { return b.checked; }).length;
    var t = n === 0 ? '' : n >= 2 ? cnt.getAttribute('data-many') : cnt.getAttribute('data-one');
    cnt.textContent = (t || '').replace('{n}', n);
  }
  boxes.forEach(function (b) { b.addEventListener('change', count); });

  /* narrow-it-down tool */
  var tool = root.querySelector('[data-tool]');
  if (tool) {
    var ans = {};
    var results = [].slice.call(tool.querySelectorAll('[data-res]'));
    var idle = tool.querySelector('[data-idle]');
    tool.querySelectorAll('[data-q]').forEach(function (q) {
      var k = q.getAttribute('data-q');
      q.querySelectorAll('button').forEach(function (btn) {
        btn.setAttribute('aria-pressed', 'false');
        btn.addEventListener('click', function () {
          q.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          ans[k] = btn.getAttribute('data-v');
          var key = (ans.q1 || '') + '-' + (ans.q2 || '');
          var hit = null;
          results.forEach(function (r) {
            var keys = r.getAttribute('data-res').split(',');
            var m = keys.indexOf(key) > -1;
            r.hidden = !m;
            if (m) hit = r;
          });
          if (idle) idle.hidden = !!hit;
        });
      });
    });
  }

  /* VIN typing */
  var vin = root.querySelector('[data-vin] span');
  if (vin && !reduce) {
    var full = 'SALxxxxxxxxxxxxxx', i = 0, dir = 1;
    setInterval(function () {
      i += dir;
      if (i >= full.length + 8) dir = -1;
      if (i <= 0) { dir = 1; i = 0; }
      vin.textContent = full.slice(0, Math.min(i, full.length));
    }, 120);
  } else if (vin) { vin.textContent = 'SALxxxxxxxxxxxxxx'; }

  /* reveal on scroll */
  var rv = [].slice.call(root.querySelectorAll('.rv'));
  if (!('IntersectionObserver' in window) || reduce) { rv.forEach(function (e) { e.classList.add('in'); }); }
  else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    rv.forEach(function (e) { io.observe(e); });
  }
})();
